import React from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import { ArrowLeft } from "lucide-react";

export default function TermsPage() {
  return (
    <div data-testid="terms-page">
      <Navbar />
      <main className="bg-white">
        <div className="container-kw py-20 md:py-28 max-w-3xl">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-[color:var(--kw-muted)] hover:text-[color:var(--kw-black)] transition-colors"
          >
            <ArrowLeft className="h-4 w-4" /> Back to home
          </Link>
          <div className="eyebrow mt-8">Legal</div>
          <h1 className="mt-4 font-display font-black text-5xl md:text-6xl tracking-tight">
            Terms &amp; Conditions
          </h1>
          <p className="mt-4 text-sm text-[color:var(--kw-muted)]">
            Last updated: {new Date().toLocaleDateString("en-IN", { year: "numeric", month: "long", day: "numeric" })}
          </p>

          <div className="prose prose-neutral mt-12 space-y-8 text-[color:var(--kw-black)]">
            <section>
              <h2 className="font-display font-bold text-2xl md:text-3xl">
                1. Acceptance of Terms
              </h2>
              <p className="mt-3 text-[color:var(--kw-muted)] leading-relaxed">
                By accessing or using this website and any products operated by
                King&apos;s Wake Digital Pvt. Ltd., you agree to be bound by
                these Terms &amp; Conditions. If you do not agree, please do
                not use our services.
              </p>
            </section>

            <section>
              <h2 className="font-display font-bold text-2xl md:text-3xl">
                2. Use of the Service
              </h2>
              <p className="mt-3 text-[color:var(--kw-muted)] leading-relaxed">
                You agree to use our services only for lawful purposes and in a
                way that does not infringe the rights of others or restrict
                anyone&apos;s use and enjoyment of the services.
              </p>
            </section>

            <section>
              <h2 className="font-display font-bold text-2xl md:text-3xl">
                3. Intellectual Property
              </h2>
              <p className="mt-3 text-[color:var(--kw-muted)] leading-relaxed">
                All content, branding, and software on this website — including
                the King&apos;s Wake logo, product names (CoinsFlu, Harday), and
                platform designs — are the property of King&apos;s Wake Digital
                Pvt. Ltd. and are protected by applicable intellectual property
                laws.
              </p>
            </section>

            <section>
              <h2 className="font-display font-bold text-2xl md:text-3xl">
                4. Third-Party Links
              </h2>
              <p className="mt-3 text-[color:var(--kw-muted)] leading-relaxed">
                Our website may contain links to third-party platforms that are
                not owned or controlled by us. We are not responsible for the
                content or practices of those services.
              </p>
            </section>

            <section>
              <h2 className="font-display font-bold text-2xl md:text-3xl">
                5. Disclaimer
              </h2>
              <p className="mt-3 text-[color:var(--kw-muted)] leading-relaxed">
                The services are provided &quot;as is&quot; and &quot;as
                available&quot; without warranties of any kind. We do not
                guarantee uninterrupted or error-free operation.
              </p>
            </section>

            <section>
              <h2 className="font-display font-bold text-2xl md:text-3xl">
                6. Limitation of Liability
              </h2>
              <p className="mt-3 text-[color:var(--kw-muted)] leading-relaxed">
                To the fullest extent permitted by law, King&apos;s Wake
                Digital Pvt. Ltd. shall not be liable for any indirect,
                incidental, or consequential damages arising out of your use of
                our services.
              </p>
            </section>

            <section>
              <h2 className="font-display font-bold text-2xl md:text-3xl">
                7. Governing Law
              </h2>
              <p className="mt-3 text-[color:var(--kw-muted)] leading-relaxed">
                These Terms shall be governed by and construed in accordance
                with the laws of India. Any disputes will be subject to the
                exclusive jurisdiction of the courts in Punjab, India.
              </p>
            </section>

            <section>
              <h2 className="font-display font-bold text-2xl md:text-3xl">
                8. Contact
              </h2>
              <p className="mt-3 text-[color:var(--kw-muted)] leading-relaxed">
                Questions about these Terms? Email us at{" "}
                <a
                  href="mailto:team@kingswake.co.in"
                  className="underline underline-offset-4"
                >
                  team@kingswake.co.in
                </a>
                .
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
